
        Component.define('photo-gallery', (el, params) => {
            /**
 * O componente Each recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el           = $(el);
const $sliderPhoto = $el.find('.slider-photo');
const $sliderNav = $el.find('.slider-nav');

$sliderPhoto.slick({
    fade: true,
    arrows: false,
    asNavFor: $sliderNav,
    swipe: false,
    responsive: [
        {
            breakpoint: 980,
            settings: {
                swipe: true,
                asNavFor: null,
            }
        }
    ]
});

$sliderNav.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: $sliderPhoto,
    focusOnSelect: true,
    /*responsive: [
        {
          breakpoint: 980,
          settings: {
            centerMode: true,
          }
        }
      ]*/
});

initZoom(0);

$sliderPhoto.on("afterChange", function (slick, currentSlide) {
    //console.log(slick, );
    initZoom(currentSlide.currentSlide);

    //console.log(currentSlide.currentSlide);
    $sliderNav.find(`[data-slick-index="${currentSlide.currentSlide}"]`).find('img').click();
});

function initZoom(index){
    //console.log(index);
    let $slider = $("[data-slick-index="+index+"]").find("[data-zoom]");
    let imageUrl = $slider.attr("data-zoom");

    if($('.mobile').length === 0){
        $slider
            .wrap('<div class="zoom-container"></div>')
            .parent()
            .zoom({
                url: imageUrl,
                callback: function () {
                    //console.log("teste");
                },
            });
    }
}

$el.on('slider:next', () => $sliderNav.slick('slickNext'));
$el.on('slider:prev', () => $sliderNav.slick('slickPrev'));
$el.on('slider:goto', (e, index) => $sliderNav.slick('slickGoTo', index));

        });